import { OrderMapResponseDTO } from 'typings/dto/orderMap';
import ModelActionsService from '../ModelActionsService';
import { IOrderMapActionsService } from './IOrderMapActionsService';
import OrderViewUtils from 'utils/models/OrderViewUtils';
import NavigateFrontendUtils from 'utils/NavigateFrontend';
import DIContainer from 'services/DIContainer';
import ISliceActions from 'storage/slices/ISliceActions';
import OrderMapMapper from 'utils/mappers/OrderMap';
import IEntityApiService from 'services/entityApi/IEntityApiService';
import IModelApiService from 'services/entityApi/IModelApiService';
import IServerEventsService from 'services/serverEvents/IServerEventsService';
import { AppDispatch, RootState } from 'storage';

export default class OrderMapActionsServiceImpl
  extends ModelActionsService<OrderMap, OrderMapResponseDTO, OrderMapResponseDTO>
  implements IOrderMapActionsService
{
  private statefulUtils: DIContainer.StatefulUtils;
  constructor(
    modelStorageData: { name: DIContainer.ModelsWithActionServices; actions: ISliceActions<OrderMap> },
    modelMapper: OrderMapMapper,
    entityApiService: IEntityApiService,
    modelApiService: IModelApiService,
    subEntitiesApiServices: DIContainer.SubEntitiesApiServices,
    modelApiRootPath: string,
    serverEventsService: IServerEventsService,
    storageStateGetter: () => RootState,
    storageDispatch: AppDispatch,
    statefulUtils: DIContainer.StatefulUtils
  ) {
    super(
      modelStorageData,
      modelMapper,
      entityApiService,
      modelApiService,
      subEntitiesApiServices,
      modelApiRootPath,
      serverEventsService,
      storageStateGetter,
      storageDispatch
    );

    this.statefulUtils = statefulUtils;
  }

  public getDefaultSortFilter = <T extends LocationSearchObject>(filterRaw: T = {} as T): T => {
    // У заказа есть спецметки в фильтрах которых нет на беке и перед отправкой их надо обработать, а т.к. этот метод дёргается везде, то удобно это сделать тут;
    // пока это единичный случай спецметок, иначе придётся как-то систематизировать
    const { currentUser } = this.getStorageState().auth;
    const { customFieldAll: customFields } = this.getStorageState().customField;
    OrderViewUtils.mapFilterSpecialTokens(filterRaw, this.statefulUtils, currentUser, customFields);
    return super.getDefaultSortFilter(filterRaw, 'number', NavigateFrontendUtils.SORT_ORDER.desc);
  };

  public getList(dto: { tenantId: string }, filter: LocationSearchObject = {}, customPath?: string) {
    return super.getList(dto, filter, customPath);
  }
}
